import React from 'react'
import HomeCard from './HomeCard';
import GeologicalIcon from '../Assets/geologicalIcon.svg'
import ProductionIcon from '../Assets/productionIcon.svg'
import ReducingIcon from '../Assets/reducingIcon.svg'
import AiLedIcon from '../Assets/aiLedIcon.svg'
import WorkPlaceIcon from '../Assets/workPlaceIcon.svg'
import DefectIcon from '../Assets/defectIcon.svg'
import DigitalTwinsIcon from '../Assets/digitalTwinsIcon.svg'
import DecisionIcon from '../Assets/desiciionIcon.svg'
import AiImg from '../Assets/AiImg.png'

export default function ProjectType() {
    return (
        <div className='flex items-center justify-center mt-20'>
            <div className='w-11/12'>
                <div className='flex items-center justify-between'>
                    <div className='flex flex-col gap-8'>
                        <HomeCard img={GeologicalIcon} text="Geological Assessment" />
                        <HomeCard img={ProductionIcon} text="Optimizing Production & Scheduling" />
                        <HomeCard img={ReducingIcon} text="Reducing Downtime" />
                        <HomeCard img={AiLedIcon} text="Drilling Optimization" />
                    </div>
                    <div className='flex items-center flex-col gap-12 w-[34rem]'>
                        <div className='text-center'>
                            <h2 className='text-[2.25rem] font-[800] text-[#111928]'>Post any AI Project & Match</h2>
                            <p className='text-[1rem] text-[#6B7280] mt-2'>A Platform to Create and Manage AI Projects</p>
                        </div>
                        <div>
                            <img className='w-[17.5rem] h-[13.8rem]' src={AiImg} />
                        </div>
                    </div>
                    <div className='flex flex-col gap-8'>
                        <HomeCard img={WorkPlaceIcon} text="Workplace Safety" />
                        <HomeCard img={DefectIcon} text="Defect Detection" />
                        <HomeCard img={DigitalTwinsIcon} text="Energy Management" />
                        <HomeCard img={DecisionIcon} text="Decision Making" />
                    </div>
                </div>
            </div>
        </div>
    );
}